import * as Types from './types';

export const parseOptions = (options: string | Types.IAutocompleteOption[]): Types.IAutocompleteOption[] => {
    let resultedOptions = options as Types.IAutocompleteOption[];

    if (typeof options === 'string' && options.length) {
        try {
            resultedOptions = JSON.parse(options.replaceAll('\'', '"'));
            // eslint-disable-next-line no-empty
        } catch {}

        return resultedOptions;
    }

    return resultedOptions;
};
